import styled from 'styled-components'

interface BtnContatoProps {
  isActive: boolean;
}

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;
  padding: 0 5px;

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: 100%;

  transition: opacity 0.3s ease-in-out;

  h3 {
    width: 80%;
    font-size: 20px;
    font-weight: normal;
    margin-bottom: 10px;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    strong {
      color: ${props => props.theme.colors.mainColor};
    }
  }

  > span {
    font-weight: 500;
    padding: 0 15px;
    width: 100%;
  }

  form,
  .collapse {
    width: 100%;
  }
`

export const RadioButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position:relative;

  width: 100%;
  padding: 10px 12px 5px;
  transition: .2s;

  > label {
    transform: translateY(-12px);
    font-size: 14px;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    margin: 0 auto;
  }

  @media screen and (max-width: 700px) {
    padding: 10px 5px 5px;

    > div {
      justify-content: space-evenly;
    }
  }
`

export const BtnContato = styled.button<BtnContatoProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  border: 2px solid ${props => props.isActive? props.theme.colors.mainColor : '#DEE3E1'};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);
  background-color: #FFF ;

  padding: 8px 60px;

  font-size: 16px;
  color: ${props => props.isActive? props.theme.colors.mainColor : '#8E9191'};

  &:focus {
    text-decoration: underline;
  }

`

export const BenefBox = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;

  margin-bottom: 10px;
  padding: 15px 10px;

  border-radius:4px;
  background-color: #FFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);

  transition: .2s all ease-in-out;

  small {
    width: 100%;
    text-align: left;
    padding: 0 10px;
    margin-bottom: 10px;
  }

  > svg {
      position: absolute;
      width: 20px;
      height: 20px;

      top: 10px;
      right: 10px;
      cursor: pointer;
      color: ${props => props.theme.colors.dange};
      z-index: 999;
      transition: 0.2s all ease-in-out;

      &:hover {
        transform: scale(1.1);
      }
    }
`

export const BenefBoxInfos = styled.div`
  width: 100%;

  > div {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
    padding: 5px 12px;
    width: 100%;

    background: #fff;
    border-radius: 4px;
    border: 2px solid #f4f6f5;
    box-shadow: 0px 2px 4px rgba(61, 69, 67, 0.05);

    color: ${props => props.theme.colors.greyDarker};

    span {
      font-size: 12px;
      font-weight: 550;
      letter-spacing: 0.1em;
      color: ${props => props.theme.colors.grey02};
      margin-bottom: 5px;
      padding-left: 2px;
    }

    p {
      font-weight: 550;
    }

    > div {
      display: flex;
      align-items: center;
      margin-bottom: 5px;

      svg {
        width: 20px;
        height: 20px;
        font-weight: bold;
        color: ${props => props.theme.colors.mainColor};
        margin-right: 15px;
      }
    }
  }
`
